module.exports = {};
module.exports.default = {};



// WEBPACK FOOTER //
// ./src/mock/dns/index.js